var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group bootstrap-timepicker"},[_c('input',{ref:"input",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.durationTimeFormat},on:{"change":_vm.onChange}}),_vm._v(" "),(_vm.showIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"pg-clock"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7604adac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeCodes/DurationTimeInput.vue
// module id = 3I+A
// module chunks = 1